import { APICore } from './apiCore'

const api = new APICore()

function getPrioridades (params) {
  const baseUrl = '/prioridad-incidencias'
  return api.get(baseUrl, params)
}

// function getIncidencia (id) {
//   const baseUrl = `/incidencias/${id}`
//   return api.get(baseUrl, {})
// }

// function addIncidencia (params) {
//   const baseUrl = '/incidencias'
//   return api.create(baseUrl, params)
// }

// function updateIncidencia (params) {
//   const baseUrl = '/incidencias'
//   return api.update(baseUrl, params)
// }

// function deleteIncidencia (params) {
//   const baseUrl = '/incidencias'
//   return api.delete(baseUrl, params)
// }

export { getPrioridades }//, getIncidencia, addIncidencia, updateIncidencia, deleteIncidencia
